module.exports = __webpack_public_path__ + "media/fr_fr_s1_Jerome.8e6d2324.oga";